import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/chatagent-logo.svg'


const _hoisted_1 = { class: "row justify-center full-width" }
const _hoisted_2 = {
  key: 0,
  class: "logo"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.pitchyou.de",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "img-fluid"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "q-pl-xl q-pr-xl justify-center"
}
const _hoisted_6 = { class: "row full-width justify-center items-center q-pa-md" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 0,
  class: "copyright text-center q-pa-md q-mt-xs bg-secondary"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomFooter',
  props: [
  'showTermsOfUse',
  'showPitchYouLogo',
  'showCopyright',
  'imprintUrl',
  'dataPrivacyUrl',
  'imprintText'
],
  setup(__props) {

let name = 'CustomFooter';

const props = __props;

let showTermsOfUse: boolean | undefined = props.showTermsOfUse;
let showPitchYouLogo: boolean | undefined = props.showPitchYouLogo;
let showCopyright: boolean | undefined = props.showCopyright;
let imprintUrl: string | undefined = props.imprintUrl;
let dataPrivacyUrl: string | undefined = props.dataPrivacyUrl;
let imprintText: string | undefined = props.imprintText;
function currentYear() {
  return new Date().getFullYear();
}

return (_ctx: any,_cache: any) => {
  const _component_q_footer = _resolveComponent("q-footer")!

  return (_openBlock(), _createBlock(_component_q_footer, {
    elevated: "",
    class: "bg-secondary text-white q-pt-md q-mt-lg"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(showPitchYouLogo))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : _createCommentVNode("", true),
        (_unref(imprintText))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(imprintText)), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            class: "text-white q-pa-sm",
            href: _unref(imprintUrl),
            target: "_blank"
          }, _toDisplayString(_ctx.$t('message.legalNoticeFLbl')), 9, _hoisted_7),
          _createElementVNode("a", {
            class: "text-white q-pa-sm",
            href: _unref(dataPrivacyUrl),
            target: "_blank"
          }, _toDisplayString(_ctx.$t('message.privacyPolicyFLbl')), 9, _hoisted_8),
          _withDirectives(_createElementVNode("a", {
            class: "text-white q-pa-sm",
            href: "https://www.pitchyou.de/nutzungsbedingungen",
            target: "_blank"
          }, _toDisplayString(_ctx.$t('message.termsOfUseFLbl')), 513), [
            [_vShow, _unref(showTermsOfUse)]
          ])
        ]),
        (_unref(showCopyright))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, " © " + _toDisplayString(currentYear()) + " TalentsConnect Operations GmbH ", 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})